<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2025-03-03 13:44:14
 * @LastEditors: sjq
 * @LastEditTime: 2025-03-03 13:56:36
 -->
<template>
  <div class="continer_box">
    <div class="pay-success" :class="isWxk ? 'wxk_success_bg_top' : ''">
      <!-- 菜单栏（内嵌App时隐藏） -->
      <app-header :title="title" :transparent="true" back-type="back-app" :leftStyle="isWxk ? 'color:#000' : ''" />
      <!-- 购买成功 -->
      <!-- 无限卡 -->
      <div v-if="isWxk" class="pay-wxk-status">
        <img class="pay-wxk-status-bg" src="../../../images/payment/wxk_success_bg.png" alt="" />
        <div class="course-text">
          <div class="course-success">
            <img class="img-icon" src="../../../images/auth/auth_radio_checked.png" alt="" />
            购买成功
          </div>
          <div class="desk">恭喜您成为无限卡会员</div>
        </div>
        <div class="yh-imgs">
          <img v-if="isImg" src="../../../images/payment/yh.gif" alt="" />
        </div>
      </div>
      <div class="pay-status" v-else>
        <span class="img-success"></span>
        <!-- 代付成功 -->
        <div class="course-text" v-if="payStatus.payAnother">
          <div class="course-success">支付成功</div>
        </div>
        <!-- 无限卡购买领取 -->
        <div v-else-if="payStatus.isVipForever" class="course-text">
          <div class="course-success">恭喜您成为友邻无限卡会员</div>
          <div class="desk">{{ isNative() ? '截图此页在微信中添加班主任微信' : '享有无限畅听权益' }}</div>
        </div>
        <!-- 单向街免费领取 -->
        <div v-else-if="payStatus.isFrereget" class="course-text">
          <div class="course-success">恭喜您！领取成功</div>
          <div class="desk">可在我的-卡券查看并使用</div>
        </div>
        <div v-else-if="fromIntegral" class="course-text">
          <div class="course-success">恭喜您！购买成功</div>
          <div class="desk">可在友邻少年公众号底部菜单中查询物流信息</div>
        </div>
        <!-- 组合商品没有goodsId -->
        <div v-else-if="isNaN(goodsId)" class="course-text">
          <div class="course-success">恭喜您！购买成功</div>
        </div>
        <!-- 优惠券 -->
        <div class="course-text" v-else-if="payStatus.goods_type === '80001'">
          <div class="course-success">优惠劵已发送至您的账户</div>
          <div class="course-success">可登录友邻少年APP-我的-卡券中查看</div>
        </div>
        <!-- 通用购买提示 -->
        <div v-else class="course-text">
          <div class="course-success">恭喜您！购买成功</div>
          <!--2022年11月21日 新增 实物商品 -->
          <div
            class="desk coupon_tip"
            v-if="
              payStatus.goods_type === '90001' ||
              (payStatus.goods_type === '50001' && payStatus.equity_type === 'renewal_year')
            "
          ></div>
          <!-- 其他 -->
          <!-- <div class="desk" v-else>{{ isNative() ? '' : '快去友邻少年APP学习吧' }}</div> -->
        </div>
      </div>
      <!-- 用户 -->
      <PayUser :fromIntegral="fromIntegral" :user="payStatus" :goodsId="goodsId" :success="true" :isWxk="isWxk" />
    </div>
  </div>
</template>

<script>
// 商品订单的成功页面
import { mapGetters } from 'vuex'
import Body from '@/mixins/body'
import PayUser from './components/pay-user'
import { appUser } from '@/utils'
import { defaultAdviserImg } from '@/pages/config'

export default {
  name: 'pay-success',
  components: { PayUser },
  mixins: [Body],
  data() {
    return {
      title: '',
      isImg: false,
      defaultAdviserImg
    }
  },
  computed: {
    ...mapGetters('payment/order', [
      'payStatus' // 支付状态
    ]),
    ...mapGetters('goods/vip', ['isNeedAuthentic']),
    ...mapGetters('args', ['fromIntegral']),
    to() {
      return { name: 'confirmOrder' }
    },
    goodsId() {
      return this.$route.params.id
    },
    // 是否是指定无限卡
    isWxk() {
      let equityType = ['renewal', 'renewal_year', 'forever']
      return (
        this.payStatus.goodsType === '50001' && equityType.findIndex(item => item === this.payStatus.equityType) !== -1
      )
      // let goodsList = appUser.isTestEnv ? [104314] : [109298, 109505, 109517]
      // return goodsList.findIndex(item => item === this.payStatus.goodsId * 1) !== -1
    }
  },
  activated() {
    const { goodsId } = this
    this.$store.commit('payment/order/getPayStatus', { goodsId })
    try {
      // 调用IOS的方法 允许左滑手势
      const bridge = window.WebViewJavascriptBridge
      if (bridge) {
        bridge.send('allowsBackForwardGestures', 'disable')
      }
    } catch (e) {
      console.log(e)
    }
    console.log(this.fromIntegral)
    console.log(this.payStatus, goodsId, 'payStatus')
  },
  methods: {
    isNative() {
      return appUser.isNative
    }
  },
  mounted() {
    // setTimeout(() => {
    //   this.isImg = true
    // }, 1000)
    this.$nextTick(() => {
      this.isImg = true
    })
  }
}
</script>

<style lang="scss" scoped>
.continer_box {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f7f9fb;
}
.pay-wxk-status {
  position: relative;
  .pay-wxk-status-bg {
    width: 100%;
  }
  .yh-imgs {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 1rem;
    img {
      width: 100%;
    }
  }
  .course-text {
    position: absolute;
    top: 0;
    width: 100%;
    text-align: center;
    margin-top: 1rem;
    color: #00b25a;
    font-size: 0.28rem;
    .course-success {
      margin-bottom: 0.32rem;
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: center;
      .img-icon {
        border-radius: 50%;
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.16rem;
      }
    }
    .desk {
      font-size: 0.52rem;
      font-weight: bold;
    }
  }
}

.pay-success {
  background: url('../../../images/payment/success_BG_ellipse_left.png') no-repeat,
    url('../../../images/payment/success_BG_ellipse_right.png') no-repeat,
    url('../../../images/payment/success_BG.png') no-repeat;
  background-color: #f7f9fb;
  background-size: 52px 79px, 65px 100px, 100% 40%;
  background-position-x: left, right, center;
  background-position-y: 22%, 7%, top;
  //position: fixed;
  //left: 0;
  //right: 0;
  //top: 0;
  //bottom: 0;
  // 支付状态
  .pay-status {
    font-size: 18px;
    font-weight: bold;
    padding: 20px 0 20px 0;
    color: white;
    text-align: center;
    .img-success {
      display: inline-block;
      width: 48px;
      height: 48px;
      border: 1px solid rgba(255, 255, 255, 1);
      border-radius: 50%;
      margin-bottom: 20px;
      background: url('../../../images/payment/icon_choose_large_def.png') no-repeat;
      background-size: 20px;
      background-position: center;
    }
    // 课程引导
    .course-text {
      .course-success {
        font-weight: bold;
        font-size: 16px;
        color: #ffffff;
        opacity: 1;
      }
      // 进入书桌
      .desk {
        margin-top: 10px;
        height: 17px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
        line-height: 17px;
      }
      .coupon_tip {
        font-size: 15px;
        font-weight: 600;
        color: #ffffff;
        margin: 0 15%;
        padding: 0.2rem 0 0.3rem;
      }
    }
  }
}
.wxk_success_bg_top {
  background: #fff6e5 url(../../../images/payment/wxk_success_bg_top.png) no-repeat;
  background-size: 100% auto;
  background-position: top;
  padding-bottom: 20px;
  min-height: 100vh;
}
</style>
